module.exports = __webpack_public_path__ + "img/RJC_LP_nachhaltigkeit.928d0d5.jpg";